module.exports = __webpack_public_path__ + "img/slide-14-7.0f1c50f1.jpg";